import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function create(data) {
  const response = await http
    .postData("/suket/gawat-darurat", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/suket/gawat-darurat/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/suket/gawat-darurat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http
    .getData(`/suket/gawat-darurat/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/suket/gawat-darurat/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function sign(id: number, data) {
  const response = await http
    .postData(`/suket/gawat-darurat/${id}/signature`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/suket/gawat-darurat/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  sign,
  print
};
